import { formatInTimeZone, utcToZonedTime, zonedTimeToUtc } from "date-fns-tz"

const timeZone = process.env.TZ!

export const DATE_FORMAT = "dd-MMM-yyyy"
export const DATE_TIME_FORMAT = "dd-MMM-yyyy HH:mm"

/** Formats date in "dd-MMM-yyyy HH:mm" format using timezone defined by process.env.TZ */
export function formatDateTime(date: Date, tz = timeZone) {
  return formatInTimeZone(date, tz, DATE_TIME_FORMAT)
}

/** Formats date in "dd-MMM-yyyy" format using timezone defined by process.env.TZ */
export function formatDate(date: Date) {
  return formatInTimeZone(date, timeZone, DATE_FORMAT)
}

/** Converts date to date with 00:00:00 UTC. Should be used to filter @db.Date columns from the frontend. */
// Converts Sep 13 2023 00:00:00 GMT+0300 to Sep 13 2023 03:00:00 GMT+0300 (Sep 13 2023 00:00:00 UTC)
// Converts Sep 13 2023 00:00:00 GMT+0530 to Sep 13 2023 05:30:00 GMT+0530 (Sep 13 2023 00:00:00 UTC)
export function convertMidnightUTC(date: Date) {
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()))
}

/** Time zone aware date calculations, e.g. `calcZonedDate(date, startOfDay) */
export function calcZonedDate(date: Date, fn: (date: Date) => Date) {
  const inputZoned = utcToZonedTime(date, timeZone)
  const fnZoned = fn(inputZoned)
  const outputZoned = zonedTimeToUtc(fnZoned, timeZone)
  return outputZoned
}
